import Es6Promise from 'es6-promise';
import store from '../../../store';

Es6Promise.polyfill();

class Utils {

    constructor() {
    }

    getUserName() {
        return store.state.userInfo.username;
    }

}

export default Utils;
